<script setup>
import LandingFeatures from '@/views/landing/LandingFeatures.vue'
import LandingFooter from '@/views/landing/LandingFooter.vue'
import LandingHero from '@/views/landing/LandingHero.vue'
import LandingNav from '@/views/landing/LandingNav.vue'
import LandingPricingPlaceholder from '@/views/landing/LandingPricingPlaceholder.vue'

definePage({
  meta: {
    layout: 'blank',
    public: true,
  },
})
</script>

<template>
  <div class="landing-page">
    <LandingNav />
    <main id="main-content">
      <LandingHero />
      <LandingFeatures />
      <LandingPricingPlaceholder />
    </main>
    <LandingFooter />
  </div>
</template>

<style lang="scss" scoped>
.landing-page {
  min-block-size: 100dvh;
  display: flex;
  flex-direction: column;
  background: rgb(var(--v-theme-background));
}

.landing-page > main {
  flex: 1 0 auto;
}
</style>
